import { BaseUserQuery } from 'graphql/documents'
import { useLazyQuery } from 'lib/useLazyQuery'
import { BaseUserQueryResult, BaseUserQueryVariables } from 'graphql/generated'
import { useCallback } from 'react'

export function useGetAttendee() {
  const loadBaseUser = useLazyQuery<
    BaseUserQueryResult,
    BaseUserQueryVariables
  >(BaseUserQuery, 'cache-first')

  return useCallback(
    async (chimeAttendeeId: string, externalUserId?: string) => {
      if (!externalUserId) {
        return {
          name: chimeAttendeeId
        }
      }

      if (externalUserId.startsWith('bot:')) {
        return {
          name: 'Bot'
        }
      }

      if (externalUserId.startsWith('aws:MediaPipeline')) {
        return {
          name: 'AWS'
        }
      }

      const resp = await loadBaseUser({
        id: externalUserId.replace('user:', '')
      })
      const user = resp.data.user
      if (!user) {
        return {
          name: chimeAttendeeId
        }
      }

      return {
        name: user.shortDisplayName || user.displayName || user.id,
        ...user
      }
    },
    [loadBaseUser]
  )
}
